import router from "@/router"
import axios from "axios"

export default ({
    namespaced: true,
    state: {
        companies: [],
        company: {},
        currentPage: 1,
        search: '',
        size: 10,
        order: 'created_at',
        add: {},
        totalPages: 0,
        selectedDelete: [],
        errorMessages: []
    },
    mutations: {
        setAllCompanies(state, companies) {
            state.companies = companies
            state.totalPages = Math.ceil(companies.total / state.size) || 0
        },
        setCompany(state, company) {
            state.company = company
        }
    },
    actions: {
        async getAll({ commit, dispatch, rootState, state }) {
            const filter = 'search=' + state.search + '&size=' + state.size + '&order=' + state.order + '&page=' + state.currentPage
            const url = rootState.baseUrl + '/api/v1/companies'
            // console.log(rootState.auth.accessToken)
            // console.log(rootState.auth.refreshToken)
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + '?' + filter, { headers: header })
                .then(response => {
                    commit('setAllCompanies', response.data)
                })
                .catch(async (error) => {
                    console.log(error)
                    await this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async add({ state, rootState }, params) {
            const url = rootState.baseUrl + '/api/v1/companies'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.post(url, params, { headers: header })
                .then(response => {
                    this.dispatch('company/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    // state.errorMessages.push(error.response.data)
                })
        },
        async delete({ state, rootState }, data) {
            const url = rootState.baseUrl + '/api/v1/companies/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }

            await Promise.all(
                data.map(id => axios.delete(url + id, { headers: header, data: {} }))
            );
            await this.dispatch('company/getAll')
        },
        async get({ commit, rootState, state }, data) {
            const url = rootState.baseUrl + '/api/v1/companies/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + data, { headers: header })
                .then(response => {
                    commit('setCompany', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async edit({ state, rootState }, params) {
            const id = state.company.id
            const url = rootState.baseUrl + '/api/v1/companies/' + id
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.patch(url, params, { headers: header })
                .then(response => {
                    this.dispatch('company/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    // state.errorMessages.push(error.response.data)
                })
        },
    }
})